import Button from "../Button/Button";
import { Plus } from "../Icon/Icon";
import styles from "./FiltersEmptyState.module.scss";

function FiltersEmptyState({ addFilter }: { addFilter: () => void }) {
  return (
    <div className={styles.emptyState}>
      <p className={styles.emptyStateText}>This table has no filters</p>
      <Button
        className={styles.emptyStateButton}
        variant="outline"
        size="small"
        leftIcon={<Plus />}
        onClick={addFilter}
      >
        Add filter
      </Button>
    </div>
  );
}

export default FiltersEmptyState;
